import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const SECTIONS = [
  { id: "home", label: "Home" },
  { id: "services", label: "Services" },
  { id: "about", label: "About" },
];

export const Header = () => {
  const { pathname } = useLocation();
  const onHome = pathname === "/";
  const [active, setActive] = useState("home");

  useEffect(() => {
    if (!onHome) return;
    const ids = [...SECTIONS.map((s) => s.id), "contact"];
    const onScroll = () => {
      const atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4;
      if (atBottom) return setActive("contact");
      let current = "home";
      ids.forEach((id) => {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= window.innerHeight * 0.4) current = id;
      });
      setActive(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [onHome]);

  const cur = onHome ? active : pathname.replace("/", "");
  const href = (id) => (onHome ? `#${id}` : `/#${id}`);
  const cls = (id) => (cur === id ? "is-active" : "");

  return (
    <header className="nav-wrap" data-testid="site-header">
      <div className="nav shell">
        <Link className="brand" to="/" data-testid="header-logo-link">
          <img src="/assets/bs_logo_small.png" alt="The Blake Smith Company BS monogram" width="48" height="54" />
          <span>THE BLAKE SMITH COMPANY</span>
        </Link>
        <span className="nav-divider" aria-hidden="true" />
        <nav aria-label="Main navigation" className="nav-links">
          {SECTIONS.map((l) => (
            <a key={l.id} href={href(l.id)} className={cls(l.id)} data-testid={`nav-${l.id}-link`}>{l.label}</a>
          ))}
          <Link to="/work" className={cls("work")} data-testid="nav-work-link">Work</Link>
          <Link to="/founder" className={cls("founder")} data-testid="nav-founder-link">Founder</Link>
          <a href={href("contact")} className={cls("contact")} data-testid="nav-contact-link">Contact</a>
        </nav>
      </div>
    </header>
  );
};
